'use strict';

/**
 * @typedef {'home' | 'discovery' | 'analysis' | 'files' | 'external'} ProjectToolKind
 */

/** Stable ids for non-discovery tools and grouping. */
export const PROJECT_TOOL_IDS = {
	HOME: 'home',
	RESULTS: 'results',
	RESULTS_DELIVERABLES: 'results-deliverables',
	RESULTS_SPECTRAL: 'results-spectral',
	STATS: 'stats',
	PATHWAYS: 'pathways',
	IBP: 'ibp',
};

/** Sidebar / navigation grouping (second group = bioinformatics). */
export const PROJECT_TOOL_GROUP = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
};
